import { memo } from 'react';

import { DEFAULT_ROUTES } from '@mais-retorno-front/constants/routes';
import { RetornoAdsTooltip } from './components/tooltip';

export const HighlightsText = memo<HighlightsTextProps>(
  ({ label = 'Lâminas em destaque' }) => {
    return (
      <div className="print:hidden leading-5">
        <div className="flex items-center">
          <h2 className="text-xl font-semibold">{label}</h2>
          <RetornoAdsTooltip />
        </div>
        <a
          href={DEFAULT_ROUTES.retornoAdsLp}
          title='Acessar "Retorno Ads"'
          target="_blank"
          rel="nofollow"
          className="font-light text-xs underline"
        >
          Saiba como patrocinar um fundo
        </a>
      </div>
    );
  }
);

interface HighlightsTextProps {
  label?: string;
}
